{
  "manager": {
    "badgeRefundStatus": {
      "partiallyRefunded": "Partially Refunded",
      "fullyRefunded": "Fully Refunded",
      "amountRemaining": "({amount} remaining)"
    },
    "transactionRowDetails": {
      "description": "Description",
      "originalTransaction": "Original Transaction",
      "transactionId": "Transaction ID",
      "fees": "Fees",
      "refundReason": "Refund Reason",
      "promoCode": "Promo Code",
      "discount": "Discount",
      "originalPrice": "Original Price",
      "discountAmount": "Discount Amount",
      "reason": "Reason",
      "issuedBy": "Issued By",
      "document": "Document",
      "row": "Row",
      "notes": "Notes",
      "bookings": "Bookings",
      "bookingNumber": "Booking {number}",
      "dateLabel": "Date:",
      "facilityLabel": "Facility:",
      "bookingIdLabel": "Booking ID:",
      "viewBooking": "View Booking",
      "adjustment": "Adjustment",
      "percentOff": "{percent}% off",
      "amountOff": "{'$'}{amount} off"
    }
  }
}
